import loadImage from 'blueimp-load-image'

function loadToBlobPolyfill() {
  /* eslint-disable */
  if (!HTMLCanvasElement.prototype.toBlob) {
    Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
      value: function (callback, type, quality) {
        var dataURL = this.toDataURL(type, quality).split(',')[1]
        setTimeout(function () {
          var binStr = atob(dataURL),
            len = binStr.length,
            arr = new Uint8Array(len)

          for (var i = 0; i < len; i++) {
            arr[i] = binStr.charCodeAt(i)
          }

          callback(new Blob([arr], { type: type || 'image/png' }))
        })
      },
    })
  }
}

const resize = (file, maxWidth, maxHeight) => {
  loadToBlobPolyfill()
  return loadImage(file, {
    maxWidth,
    maxHeight,
    orientation: true,
    /* if canvas isn't set to true and the browser supports reading the orientation natively,
    /* the library will return an img element instead of a canvas. 
    /* However there is currently a bug in Chrome where the aspect ratio is affected when the orientation 
    /* is changed by the browser and then `object-fit: cover` is used to display it. 
    /* And besides, the performance benefit wasn't very noticeable.
    /*  (https://bugs.chromium.org/p/chromium/issues/detail?id=1082669)
    */
    canvas: true,
    pixelRatio: window.devicePixelRatio,
  }).then(({ image }) => {
    return new Promise(resolve =>
      // toBlob is much more performant than getDataUrl
      image.toBlob(blob => {
        resolve(URL.createObjectURL(blob))
      }, 'image/jpeg')
    )
  })
}

function getCroppedImg(image, crop) {
  return new Promise(resolve => {
    const img = new Image()
    img.onload = () => {
      const imageWidth = img.width
      const imageHeight = img.height

      const cropX = (crop.x / 100) * imageWidth
      const cropY = (crop.y / 100) * imageHeight

      const cropWidth = (crop.width / 100) * imageWidth
      const cropHeight = (crop.height / 100) * imageHeight

      const destWidth = cropWidth
      const destHeight = cropHeight
      const canvasWidth = cropWidth
      const canvasHeight = cropHeight

      const canvas = document.createElement('canvas')
      canvas.width = canvasWidth
      canvas.height = canvasHeight
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, cropX, cropY, cropWidth, cropHeight, 0, 0, destWidth, destHeight)
      loadToBlobPolyfill()
      canvas.toBlob(blob => resolve(URL.createObjectURL(blob)), 'image/jpeg', 0.7)
    }
    img.src = image
  })
}

/* eslint no-bitwise: "off" */

export { resize, getCroppedImg }
